<template>
  <div>
    <div class="header_box">
      <AppNewHeader :userName="userName" :placeholderText="'请输入数据库名称'" />
    </div>
    <div class="order-container">
      <!-- 用户信息表单 -->
      <el-form
        :model="userForm"
        :rules="rules"
        ref="userFormRef"
        label-width="80px"
        class="user-form"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="联系人" prop="name">
              <el-input
                v-model="userForm.name"
                placeholder="请输入联系人姓名"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="电话" prop="phone">
              <el-input v-model="userForm.phone" placeholder="请输入联系电话" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="userForm.email" placeholder="请输入电子邮箱" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="机构" prop="organization">
              <el-input
                v-model="userForm.organization"
                placeholder="请输入机构名称"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 订单商品表格 -->
      <el-table
        :data="orderItems"
        row-key="id"
        :row-style="{ width: '100%', height: '54px' }"
        class="order-table"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#606266',
          fontWeight: 'bold',
        }"
      >
        <el-table-column
          show-overflow-tooltip
          property="knwoledgeTitle"
          label="知识库名称"
        />
        <!-- <el-table-column
          show-overflow-tooltip
          property="publishUnit"
          label="出版社"
        /> -->
        <!-- <el-table-column show-overflow-tooltip label="价格">
          <template #default="scope">
            {{
              scope.row.knowledgeVersion === "netVersion"
                ? scope.row.currentPrice
                : scope.row.mirrorPrice
            }}
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          property="concurrentNum"
          label="并发数"
        /> -->
        <el-table-column show-overflow-tooltip property="years" label="年限" />
        <el-table-column label="版本">
          <template #default="scope">
            {{
              scope.row.knowledgeVersion === "netVersion"
                ? "网络版本"
                : "镜像版本"
            }}
          </template>
        </el-table-column>
      </el-table>

      <!-- 订单汇总信息 -->
      <div class="order-summary">
        <div class="summary-item">
          <div
            style="display: flex; justify-content: space-between; width: 207px"
          >
            <div>知识库数量:</div>
            <div>{{ route.query.count || orderItems.length }}件</div>
          </div>
        </div>
        <!-- <div class="summary-item total">
          <span>合计金额:</span>
          <span>￥{{ route.query.total || calculateTotal() }}万</span>
        </div> -->
        <el-button
          v-if="butValue === '0'"
          type="warning"
          class="submit-btn"
          @click="submitOrder('0')"
          :loading="submitting"
        >
          申请试用
        </el-button>
        <el-button
          v-if="butValue === '1'"
          type="primary"
          class="submit-btn"
          @click="submitOrder('1')"
          :loading="submitting"
        >
          确认下单
        </el-button>
      </div>
    </div>
    <el-footer>
      <AppFooter></AppFooter>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useOrderStore } from "@/views/stores/order.js";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import AppFooter from "@/views/components/AppFooter.vue";
import { PostOrderList, PostOrderDeleteList } from "@/api/index";
import { Cookie } from '@/utils/Cookie'
const orderStore = useOrderStore();
const orderItems = ref([]);
const route = useRoute();
const router = useRouter();

const butValue = ref("");
const submitting = ref(false);
const userName = ref("");
const saleUserList = ref([
  {
    name:'崔经理',
    phone:'18991958688',
    area:'上海，浙江，安徽，山东，重庆，四川，甘肃，青海，宁夏，广东，天津，北京，湖北'
  },{
    name:'祝经理',
    phone:'17392256904',
    area:'黑龙江，吉林，辽宁、河北、河南、广西、湖南、贵州'
  },{
    name:'王经理',
    phone:'18592036215',
    area:'福建，海南，江苏，江西，内蒙古，山西，西藏，新疆，云南'
  },
]);
// 用户表单数据
const userForm = ref({
  name: '',
  phone: "",
  email: "",
  organization: "",
});

// 表单验证规则
const rules = {
  name: [
    { required: true, message: "请输入联系人姓名", trigger: "blur" },
    { min: 2, max: 10, message: "长度在2到10个字符", trigger: "blur" },
  ],
  phone: [
    { required: true, message: "请输入联系电话", trigger: "blur" },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: "请输入正确的手机号码",
      trigger: "blur",
    },
  ],
  email: [
    { required: true, message: "请输入邮箱地址", trigger: "blur" },
    {
      type: "email",
      message: "请输入正确的邮箱地址",
      trigger: ["blur", "change"],
    },
  ],
  organization: [
    { required: true, message: "请输入机构名称", trigger: "blur" },
    { min: 2, max: 50, message: "长度在2到50个字符", trigger: "blur" },
  ],
};

const userFormRef = ref(null);
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get('token')) || '';
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get('userInfo')) || null;
    const user = userString || null;   
        userName.value = user?.realName;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};
onMounted(() => {
     checkTokenStatus();
  butValue.value = route.query.isding;
  orderItems.value = orderStore.items;
  // const userString = JSON.parse(Cookie.get('userInfo')) || null;
  // const user = userString || null;
  // userName.value = user;
});

const handleClearOrder = async (dataValue) => {
  const transformData = (data) => {
    return data.map((item) => ({
      id1s: item.id,
    }));
  };

  const dataList = transformData(dataValue);
  const arrayString = `["${dataList.map((item) => item.id1s).join('","')}"]`;
  const jsonArray = JSON.parse(arrayString);
  console.log(jsonArray, "jsonArray");

  const res = await PostOrderDeleteList({ id1s: jsonArray });

  try {
    if (res.info) {
      console.log(res, "清空采购清单");
    }
  } catch (error) {
    console.log(error);
  }
};

// 计算总金额
const calculateTotal = () => {
  const total = orderItems.value.reduce((sum, item) => {
    const price =
      item.knowledgeVersion === "netVersion"
        ? item.currentPrice
        : item.mirrorPrice;
    const years = item.years || 1; // 如果年限不存在，默认为1
    return sum + (price || 0) * years;
  }, 0);
  return (total / 10000).toFixed(2);
};

// 提交订单
const submitOrder = async (a) => {
  // First check authentication status
  const token = JSON.parse(Cookie.get('token')) || '';
  if (!token || isTokenExpired(token)) {
    ElMessage.warning("请先登录后再提交订单");
    // router.push("/login");
    return;
  }

  const transformData = (data) => {
    return data.map((item) => ({
      orderName: item.knwoledgeTitle,
      knowledgeId: item.knowledgeId,
      orderAmount:
        item.knowledgeVersion === "netVersion"
          ? item.currentPrice
          : item.mirrorPrice,
      sy: a,
      orderCount: item.years,
      publishUnit: item.publishUnit,
      versionType: item.knowledgeVersion === "netVersion" ? 0 : 1,
      buyUserName: userForm.value.name,
      buyUserPhone: userForm.value.phone,
      buyUserEmail: userForm.value.email,
      buyUserUnit: userForm.value.organization,
      peopleCount: item.concurrentNum,
      saleUserName: "崔经理",
      saleUserPhone: "18991958688",
      count: item.years,
    }));
  };

  try {
    // Validate form first
    await userFormRef.value.validate();

    // Check if there are items to order
    if (!orderItems.value || orderItems.value.length === 0) {
      ElMessage.warning("没有可提交的订单项目");
      return;
    }

    submitting.value = true;
    const transformedData = transformData(orderItems.value);

    // Make API call
    const res = await PostOrderList({ userorders: transformedData });

    if (res.info) {
      ElMessage.success("下单成功");
      // Clear the order after successful submission
      await handleClearOrder(orderItems.value);
      // Redirect to completion page
        localStorage.removeItem("addCardListParams");
      router.push({
        path: "OrderCompletPage",
      });
    } else {
      console.log(res.message || "下单失败");
    }
  } catch (error) {
    console.error("下单出错:", error);
    if (error.fields) {
      ElMessage.warning("请填写完整的用户信息");
    } else if (error.response?.status === 401) {
      ElMessage.warning("登录已过期，请重新登录");
      // router.push("/login");
    } else {
      ElMessage.error(error.message || "下单失败，请稍后重试");
    }
  } finally {
    submitting.value = false;
  }
};

// Token expiration check function
// const isTokenExpired = (token) => {
//   try {
//     const payload = JSON.parse(atob(token.split(".")[1]));
//     return payload.exp && Date.now() >= payload.exp * 1000;
//   } catch (e) {
//     console.error("Token验证错误:", e);
//     return true;
//   }
// };
</script>

<style scoped>
.order-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 538px;
}

.user-form {
  /* margin-bottom: 30px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px; */
}

.order-table {
  border: 1px solid #ebeef5;
  border-bottom: none;
}

/* 隐藏所有垂直竖线 */
.order-table td,
.order-table th.is-leaf {
  border-right: none !important; /* 隐藏单元格右侧竖线 */
  border-left: none !important; /* 隐藏单元格左侧竖线 */
}

/* 保留单元格底边框 */
.order-table td {
  border-bottom: 1px solid #ebeef5 !important;
}

/* 隐藏表格默认的右侧伪元素竖线 */
.el-table--border::after,
.el-table--group::after {
  width: 0 !important;
}

/* 隐藏表头的默认下边框 */
.order-table th.is-leaf {
  border-bottom: none !important;
}

/* 强制显示表头底边框（若需要） */
.order-table thead {
  border-bottom: 1px solid #ebeef5 !important;
}

.order-summary {
  margin-top: 30px;
  padding: 20px;
  background: #f5f7fa;
  border-radius: 4px;
  text-align: right;
}

.summary-item {
  margin-bottom: 10px;
  font-size: 16px;
  display: flex;
  justify-content: right;
}

.summary-item span:first-child {
  margin-right: 46px;
  color: #666;
}

.summary-item.total {
  font-size: 18px;
  font-weight: bold;
  color: #e32929;
}

.submit-btn {
  margin-top: 20px;
  width: 150px;
  height: 42px;
  font-size: 16px;
}

/* 响应式布局 */
/* @media (max-width: 768px) {
  .el-col {
    width: 100%;
    margin-bottom: 15px;
  }

  .user-form {
    padding: 15px;
  }
} */
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}
::v-deep .el-form-item__label {
  padding: 0 25px 0 0 !important;
}
::v-deep(.el-scrollbar__bar){
  display: none;
}
</style>
